import React, { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { LeadViewAllTabsProps } from "./lead-view-all-tabs-props";
import { CustomTabPanelComponent } from "../../../common/components";
import LeadViewDetails from "./lead-view-details/lead-view-details";
import LeadViewAdditionalDetails from "./lead-view-additional-details/lead-view-additional-details";
import LeadViewTimeline from "./lead-view-timeline/lead-view-timeline";
import LeadViewDetailsViewAttachmentInfo from "./lead-view-details/lead-view-details-view/lead-view-details-view-attachment-info/lead-view-details-view-attachment-info";
import LeadViewDetailsViewProductInfo from "./lead-view-details/lead-view-details-view/lead-view-details-view-product-info/lead-view-details-view-product-info";
import LeadViewDetailsViewOpenActivitiesInfo from "./lead-view-details/lead-view-details-view/lead-view-details-view-open-activities-info/lead-view-details-view-open-activities-info";
import LeadViewDetailsViewClosedActivitiesInfo from "./lead-view-details/lead-view-details-view/lead-view-details-view-closed-activities-info/lead-view-details-view-closed-activities-info";
import LeadViewDetailsViewInvitedMeetingsInfo from "./lead-view-details/lead-view-details-view/lead-view-details-view-invited-meetings-info/lead-view-details-view-invited-meetings-info";
import LeadViewDetailsViewEmailInfo from "./lead-view-details/lead-view-details-view/lead-view-details-view-email-info/lead-view-details-view-email-info";
import LeadViewDetailsViewCampaignsInfo from "./lead-view-details/lead-view-details-view/lead-view-details-view-campaigns-info/lead-view-details-view-campaigns-info";
import "./lead-view.scss";
import { useLogin } from "../../../common/hooks/useUser";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// … rest of your imports remain the SAME…

const LeadViewDetailsAllTabsResponsive: React.FC<LeadViewAllTabsProps> = ({
  leadDetails,
  selectedLeadId,
  setLoading,
  viewFullInfoOpen,
  setViewFullInfoOpen,
  uploadedImage,
  setUploadedImage,
  uploadedImageFile,
  setUploadedImageFile,
  setRemoveImage,
  removeImage,
  fetchLeadDetails,
  leadId,
  onLeadNameUpdate,
  resetImageUpload,
  setAlertMessage,
  setAlertType,
  setAlertOpen,
  viewAddFullInfoOpen,
  setViewAddFullInfoOpen,
  disableLeadStatus,
  permissions,
  setCrumbMappingOption,
  setViewTaskvalue,
  setViewMeetingvalue,
  setViewCallValue,
  isMobile,
  setUploadError,
}) => {
    const [viewOpen, setViewOpen] = useState<boolean>(false);
      const [viewEditOpen, setViewEditOpen] = useState<boolean>(false);
      const [indexValue, setIndexValue] = React.useState(0);
      const [updatedDate, setUpdatedDate] = useState<string | undefined>();
      const [disableEdit, setDisableEdit] = useState<boolean>(false);
      const { tenantDetails } = useLogin();
  const [selectedAccordion, setSelectedAccordion] = useState(null);
    
      const handleFormSubmitError = (from?: any) => {
        if ("additionalDetails" === from) {
          setViewAddFullInfoOpen(true);
          setIndexValue(1);
          setAlertMessage(
            "Validation error in additional details tab. Please check the fields."
          );
          setAlertType("error");
          setAlertOpen(true);
        } else {
          setViewFullInfoOpen(true);
          setIndexValue(0);
          setAlertMessage(
            "Validation error in details tab. Please check the fields."
          );
          setAlertType("error");
          setAlertOpen(true);
        }
      };
    
      useEffect(() => {
        if (
          tenantDetails?.tenantType === "SuperTenant" &&
          leadDetails?.assigned_to &&
          leadDetails?.lead_status !== "Closed-Lost"
        ) {
          setDisableEdit(true);
        }
        else if (tenantDetails?.tenantType === "Tenant"
          && leadDetails?.lead_status === "Closed-Lost" 
          && leadDetails?.lead_source === "AFP"
        ) {
          setDisableEdit(true);
        }
        else setDisableEdit(false);
      }, [leadDetails]);

  const handleAccordionChange = (panel:any) => (even:any, isExpanded:any) => {
    setSelectedAccordion(isExpanded ? panel : false);
      setUploadError(null);
  };
  
  return (
    <div className="leads-view-all-tabs">
      {/* Detailed View */}
      <Box>
        {/* 1. Primary details */}
        <Accordion expanded={selectedAccordion === 'panel1'}
          onChange={handleAccordionChange('panel1')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
          >
            Primary Details
          </AccordionSummary>
          <AccordionDetails className="no-padding-accordion-details">
           <LeadViewDetails
            leadDetails={leadDetails}
            selectedLeadId={selectedLeadId}
            setLoading={setLoading}
            viewFullInfoOpen={viewFullInfoOpen}
            setViewFullInfoOpen={setViewFullInfoOpen}
            uploadedImage={uploadedImage}
            setUploadedImage={setUploadedImage}
            uploadedImageFile={uploadedImageFile}
            setUploadedImageFile={setUploadedImageFile}
            setRemoveImage={setRemoveImage}
            removeImage={removeImage}
            fetchLeadDetails={fetchLeadDetails}
            onLeadNameUpdate={onLeadNameUpdate}
            resetImageUpload={resetImageUpload}
            handleFormSubmitError={handleFormSubmitError}
            disableLeadStatus={disableLeadStatus}
            permissions={permissions}
            isMobile={isMobile}
            setUploadError ={ setUploadError}
          />
          </AccordionDetails>
        </Accordion>

        {/* 2. Additional details */}
        <Accordion expanded={selectedAccordion === 'panel2'}
          onChange={handleAccordionChange('panel2')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
          >
            Additional Details
          </AccordionSummary>
          <AccordionDetails className="no-padding-accordion-details">
            <LeadViewAdditionalDetails
            leadDetails={leadDetails}
            selectedLeadId={selectedLeadId}
            setLoading={setLoading}
            viewFullInfoOpen={viewAddFullInfoOpen}
            setViewFullInfoOpen={setViewAddFullInfoOpen}
            uploadedImage={uploadedImage}
            setUploadedImage={setUploadedImage}
            uploadedImageFile={uploadedImageFile}
            setUploadedImageFile={setUploadedImageFile}
            setRemoveImage={setRemoveImage}
            removeImage={removeImage}
            fetchLeadDetails={fetchLeadDetails}
            onLeadNameUpdate={onLeadNameUpdate}
            resetImageUpload={resetImageUpload}
            handleFormSubmitError={handleFormSubmitError}
            permissions={permissions}
            isMobile={isMobile}
          />
          </AccordionDetails>
        </Accordion>

        {/* 3. Attachments */}
        <Accordion expanded={selectedAccordion === 'panel3'}
          onChange={handleAccordionChange('panel3')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Attachments
          </AccordionSummary>
          <AccordionDetails>
            <LeadViewDetailsViewAttachmentInfo
            setLoading={setLoading}
            leadId={leadId}
            disableEdit={disableEdit}
            permissions={permissions}
            leadDetails={leadDetails}
          />
          </AccordionDetails>
        </Accordion>

        {/* 4. Activities */}
        <Accordion expanded={selectedAccordion === 'panel4'}
          onChange={handleAccordionChange('panel4')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Activities
          </AccordionSummary>
          <AccordionDetails>
             <LeadViewDetailsViewOpenActivitiesInfo
            // disableEdit={disableEdit || !permissions?.canWrite}
            leadDetails={leadDetails}
            setViewTaskvalue={setViewTaskvalue}
            setCrumbMappingOption={setCrumbMappingOption}
            permissions={permissions}
            setViewMeetingvalue={setViewMeetingvalue}
            setViewCallValue={setViewCallValue}

          />
          </AccordionDetails>
        </Accordion>

        {/* 5. Emails */}
        <Accordion expanded={selectedAccordion === 'panel5'}
          onChange={handleAccordionChange('panel5')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Communications
          </AccordionSummary>
          <AccordionDetails>
            <LeadViewDetailsViewEmailInfo
            disableEdit={disableEdit || !permissions?.canWrite}
            leadDetails={leadDetails}
          />
          </AccordionDetails>
        </Accordion>

        {/* 6. Campaigns */}
        <Accordion expanded={selectedAccordion === 'panel6'}
          onChange={handleAccordionChange('panel6')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Campaigns
          </AccordionSummary>
          <AccordionDetails>
            <LeadViewDetailsViewCampaignsInfo
            allLeadData={selectedLeadId}
            setLoading={setLoading}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            disableEdit={disableEdit || !permissions?.canWrite}
            leadDetails={leadDetails}
          />
          </AccordionDetails>
        </Accordion>

        {/* 7. Timeline */}
        <Accordion expanded={selectedAccordion === 'panel7'}
          onChange={handleAccordionChange('panel7')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Timeline
          </AccordionSummary>
          <AccordionDetails>
            <LeadViewTimeline
            selectedLeadId={selectedLeadId}
            setLoading={setLoading}
            setUpdatedDate={setUpdatedDate}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
          />
          </AccordionDetails>
        </Accordion>

      </Box>
    </div>
  );
};

export default LeadViewDetailsAllTabsResponsive;
